import Pending from "./Pending";

const OnlineAdmission = () => {
    
  return (
    <div className="ring-1 ring-[#691e78] rounded-xl">
      <div className="flex justify-between items-center cursor-pointer rounded-xl overflow-hidden bg-gray-300">
        <Pending />
      </div>
    </div>
  )
}

export default OnlineAdmission